module.exports = __webpack_public_path__ + "static/media/portofloio.d5594a5b.jpg";